export default __webpack_public_path__ + "static/media/szerszen.c7daaf9a.svg";